import {
    GridCellParams,
    GridRenderCellParams,
} from '@/global/components/DataGrid/utils/types'
import { Link } from '@/global/components/Link'
import { cn } from '@/lib/utils'
import { EspelhoPonto } from '@/service/api'
import {
    FaltaCadastrada,
    FaltaInjustificada,
    FaltaJustificada,
} from 'service/api/endpoints/faltas-cadastradas'
import { arrangeFaltasCadastradas } from './ausencias'

interface IProps {
    faltaCadastrada?: FaltaCadastrada
    faltas?: string
}
export default function FaltasCell({
    row: { faltaCadastrada, faltas = '00:00' },
}: GridCellParams<any, IProps>) {
    if (!faltaCadastrada) return faltas

    const { faltaInjustificada, faltaJustificada } = arrangeFaltasCadastradas({
        faltaCadastrada,
        faltas,
    })

    return (
        <Link
            href={`falta/detalhes/${faltaCadastrada?.id}`}
            title={generateTitle(faltaJustificada, faltaInjustificada)}
        >
            <span
                className={cn({
                    underline: !!faltaCadastrada,
                    'decoration-double': !!faltaJustificada,
                    'font-semibold': !!faltaInjustificada && !!faltaJustificada,
                })}
            >
                {faltas}
            </span>
        </Link>
    )
}

export function FaltasCellWithoutLink({
    row: { FaltaCadastrada: faltaCadastrada, faltas },
}: GridRenderCellParams<any, EspelhoPonto>) {
    if (faltas === '00:00') return null

    if (!faltaCadastrada) return faltas

    const { faltaInjustificada, faltaJustificada } = arrangeFaltasCadastradas({
        faltaCadastrada: faltaCadastrada as any,
        faltas: faltas ?? '00:00',
    })

    return (
        <span
            title={generateTitle(faltaJustificada, faltaInjustificada)}
            className={cn({
                underline: !!faltaCadastrada,
                'decoration-double': !!faltaJustificada,
                'font-semibold': !!faltaInjustificada && !!faltaJustificada,
            })}
        >
            {faltas}
        </span>
    )
}

function generateTitle(
    faltaJustificada?: FaltaJustificada,
    faltaInjustificada?: FaltaInjustificada,
) {
    let title = ''

    if (faltaJustificada) {
        title += 'Justificada'
        if (faltaJustificada.tempo) title += ` (${faltaJustificada.tempo})`
        title += ` - ${String(faltaJustificada.justificativa).slice(0, 30)}`
    }
    if (faltaInjustificada) {
        title += faltaJustificada ? '\n' + 'Injustificada' : 'Injustificada'

        if (faltaInjustificada.tempo) title += ` (${faltaInjustificada.tempo})`
    }
    return title
}
